module.exports = __webpack_public_path__ + "assets/images/WalletShade.73aac86def51cdf8ffed80029550f640.png";